import type { IQrCode } from "@/data/model/QrCode";
import type { IGetQrCodeQry } from "@/data/queries/qrcode/GetQrCodeQry";

import { BaseServiceDao } from "./BaseServiceDao";

export class QrCodeDao extends BaseServiceDao {
    public static className = "QrCodeDao";

    constructor() {
        super("qr-code");
    }

    public async getQrCode(qry: IGetQrCodeQry): Promise<IQrCode> {
        return this.get("", qry, QrCodeDao.parseQrCode);
    }

    private static parseQrCode(literal: any): IQrCode {
        return {
            imageDataUrl: literal.imageDataUrl,
        };
    }
}
